import {Spinner} from '@ui-kitten/components';
import {StyleSheet, View} from 'react-native';
import React from 'react';

const LoadingIndicator = ({style, status}) => (
  <View style={[style, styles.container]}>
    <Spinner size="small" status={status} />
  </View>
);

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default LoadingIndicator;
